import { Faq as PlatformFaq } from '@wix/premium-purchase-platform/@components';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { useRevShare } from '../../hooks';
import { useCurrentModule } from '../ModuleProvider';
export const Faq = _ref => {
  let {
    t,
    Trans,
    background
  } = _ref;
  const module = useCurrentModule();
  const {
    utils
  } = PlatformFaq.useFaq({
    componentName: 'Faq'
  });
  const {
    hasRevShare,
    isLoading
  } = useRevShare();
  const platformContext = PremiumPurchasePlatformModule.internals.useContext();
  const renderWithParams = content => utils.renderWithParams(Trans, t, content);
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(PremiumPurchasePlatformModule.Provider, {
    context: {
      ...platformContext,
      purchaseContext: {
        ...platformContext.purchaseContext,
        params: {
          revShare: hasRevShare
        }
      }
    }
  }, /*#__PURE__*/React.createElement(PlatformFaq.Root, {
    background: background,
    useLoader: true,
    onActionClick: event => {
      module.internals.bi.onFaqLinkClick == null || module.internals.bi.onFaqLinkClick({
        event
      });
    }
  }, _ref2 => {
    var _data$title, _data$items;
    let {
      data
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlatformFaq.Header, null, /*#__PURE__*/React.createElement(PlatformFaq.Title, null, t(((_data$title = data.title) == null ? void 0 : _data$title.translationKey) ?? '')), /*#__PURE__*/React.createElement(PlatformFaq.Subtitle, null, renderWithParams(data.subtitle))), /*#__PURE__*/React.createElement(PlatformFaq.Content, null, (_data$items = data.items) == null ? void 0 : _data$items.map((item, idx) => {
      var _item$question2;
      return /*#__PURE__*/React.createElement(PlatformFaq.Item, {
        key: idx,
        onItemClick: _ref3 => {
          var _item$question;
          let {
            action
          } = _ref3;
          module.internals.bi.onFaqItemClick == null || module.internals.bi.onFaqItemClick({
            action,
            questionKey: (_item$question = item.question) == null ? void 0 : _item$question.translationKey
          });
        },
        question: t(((_item$question2 = item.question) == null ? void 0 : _item$question2.translationKey) ?? ''),
        answer: renderWithParams(item.answer)
      });
    })));
  }));
};
//# sourceMappingURL=Faq.js.map